module.exports = __webpack_public_path__ + "img/oracleoke.ddaa8a0e.svg";